import { create } from 'zustand';

interface SearchResultsPage {
  page: number;
  setPage: (query: number) => void;
}

interface ForceFirstProductPage {
  force: boolean;
  setForce: (force: boolean) => void;
}

export const useArticlesPage = create<SearchResultsPage>((set) => ({
  page: 1,
  setPage: (newPage) => {
    return set({ page: newPage });
  },
}));

export const useForceFirstProductPage = create<ForceFirstProductPage>((set) => ({
  force: false,
  setForce: (newState) => {
    return set({ force: newState });
  },
}));
